<script>
    import { onMount, setContext } from 'svelte';
    import { writable } from 'svelte/store';
    import { browser } from '$app/environment';
    import { page } from '$app/stores';
    import { currentLanguage, supportedLanguages } from '$lib/i18n.js';
    import { authStore } from '$lib/stores/auth.js';
    import Navbar from '$lib/components/Navbar.svelte';
    import Footer from '$lib/components/footer/Footer.svelte';
    import '../../../app.css';

    export let data;

    const mobileFooterVisible = writable(true);
    const desktopFooterVisible = writable(true);
    setContext('layoutControls', { mobileFooterVisible, desktopFooterVisible });

    let isDesktop = false;

    onMount(() => {
        // Safely derive language from route params when data is missing
        const fallbackLang = $page?.params?.lang;
        const langToSet = data?.lang ?? fallbackLang;
        if (langToSet) {
            currentLanguage.set(langToSet);
        }
        authStore.initializeAuth();

        if (browser) {
            const mq = window.matchMedia('(min-width:768px)');
            const update = () => isDesktop = mq.matches;
            update();
            mq.addEventListener?.('change', update);
            const onResize = () => isDesktop = window.innerWidth >= 768;
            window.addEventListener('resize', onResize);
        }
    });
</script>

<div class="app">
    <main><slot /></main>
    <Navbar />

    {#if (($desktopFooterVisible && isDesktop) || ($mobileFooterVisible && !isDesktop)) && !$page.route.id?.includes('/search') && !$page.route.id?.includes('/protection')}
        <Footer />
    {/if}
</div>

<style>


	.app {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}

	main {
		flex: 1;
		display: flex;
		flex-direction: column;
		width: 100%;
		margin: 0 auto;
		box-sizing: border-box;
	}
</style>